/* eslint-disable @typescript-eslint/no-explicit-any */
import { mpfRListsHttp } from '../api/mpf-r-lists-http'
import { and, isArchivedFilter } from './data'

interface RNLTD {
  IntervalDuration: number
  IntervalFrequency: string
  IntervalType: string
  IsArchived: boolean
  ItemCreated: Date
  ItemCreatedBy: any //Person_Single
  ItemModified: Date | any
  ItemModifiedBy: any //Person_Single
  Title: string
  eKey: string
  eTag: string
}
interface RNLTDFetchArgs {
  isArchived: false | null | true
}
const COLUMN_NAMES = {
  EKey: 'eKey',
  ETag: 'eTag',
  IntervalDuration: 'IntervalDuration',
  IntervalFrequency: 'IntervalFrequency',
  IntervalType: 'IntervalType',
  IsArchived: 'IsArchived',
  ItemCreated: 'ItemCreated',
  ItemCreatedBy: 'ItemCreatedBy',
  ItemModified: 'ItemModified',
  ItemModifiedBy: 'ItemModifiedBy',
}
const LIST_NAME = 'RNLTDMetadataList'

const constructRNLTDFilter = (args: RNLTDFetchArgs): string => {
  const filters: string[] = []
  filters.push(isArchivedFilter(args.isArchived ?? null))
  const filter = and(...filters)
  return filter
}
const getRNLTDs = async (args: RNLTDFetchArgs): Promise<RNLTD[]> => {
  const list = await mpfRListsHttp().getList(LIST_NAME)
  const filter = constructRNLTDFilter(args)
  const items: any = await list
    .query()
    .filter(filter)
    .select(
      COLUMN_NAMES.IntervalFrequency,
      COLUMN_NAMES.IntervalType,
      COLUMN_NAMES.IntervalDuration,
      COLUMN_NAMES.EKey,
      COLUMN_NAMES.ETag,
      COLUMN_NAMES.IsArchived,
      COLUMN_NAMES.ItemCreated,
      COLUMN_NAMES.ItemCreatedBy,
      COLUMN_NAMES.ItemModified,
      COLUMN_NAMES.ItemModifiedBy,
    )
    .get()
  return [...items] as RNLTD[]
}

const addOrUpdateRNLTD = async (addObj): Promise<void> => {
  try {
    const andList = await mpfRListsHttp().getList(LIST_NAME)
    await andList.addOrUpdateItem(addObj)
  } catch (error) {
    console.error(error)
  }
}

async function deleteRNLTD(item) {
  const lists = (await mpfRListsHttp().getList(LIST_NAME))
  await lists.deleteItem(item.eKey, item.eTag)
}
export {
  COLUMN_NAMES,
  LIST_NAME,
  type RNLTD,
  type RNLTDFetchArgs,
  addOrUpdateRNLTD,
  deleteRNLTD,
  getRNLTDs,
}
